<template>
  <TravelersFilterPopup
    ref="calendarPopupRef"
    :title="props.title"
    :static-title="props.staticTitle"
    :is-active="props.isActive"
    :is-scroll="props.isScroll"
    :is-disabled-reset-button="props.isDisabledResetButton"
    :is-full-height="props.isFullHeight"
    :is-footer-buttons-vertical="props.isFooterButtonsVertical"
    :is-modal-only="props.isModalOnly"
    :modal-size="props.modalSize"
    :modal-no-padding="props.modalNoPadding"
    :modal-class="modalClass"
    :total-count="filterStore.totalCount"
    :is-loading="filterStore.isLoading"
    @open="open"
    @close="close"
    @reset="reset"
    @apply="apply"
  >
    <template #trigger="{ open }">
      <slot
        name="trigger"
        :open="open"
      >
        <FilterPopupChip
          :label="props.title"
          :selected="props.isActive"
          :is-scroll="props.isScroll"
          :items-count="props.itemsCount"
          @open="open"
        />
      </slot>
    </template>

    <template #default>
      <slot />
    </template>

    <template #header>
      <slot name="header" />
    </template>

    <template #footer>
      <slot name="footer" />
    </template>
  </TravelersFilterPopup>
</template>

<script lang="ts" setup>
  import { TravelersFilterPopup } from '@experience/travelers-filter-popup-package';
  import { useExcursionFiltersStore } from '@/entities/filter/store/excursion';
  import type { IExcursionFilterPopupWrapperProps, IFilterPopupWrapperEmits } from '../../model/interface.ts';
  import { useHeaderZIndex } from '@/shared/composables/useHeaderZIndex.ts';
  import FilterPopupChip from '../FilterPopupChip.vue';

  const calendarPopupRef = ref<{ open: (isForced: boolean) => void } | null>(null);

  const { decreaseZIndex, increaseZIndex } = useHeaderZIndex();

  const props = defineProps<IExcursionFilterPopupWrapperProps>();

  const modalClass = computed(() => {
    const baseClass = 'excursion-filter-popup-modal';

    return props.modalClass ? `${baseClass} ${props.modalClass}` : baseClass;
  });

  const emit = defineEmits<IFilterPopupWrapperEmits>();

  const filterStore = useExcursionFiltersStore();

  const open = (isForced: boolean) => {
    decreaseZIndex();
    emit('open', isForced);
  };

  const close = (isForciblyOpened: boolean) => {
    increaseZIndex();
    filterStore.applyPreviousParams();
    emit('close', isForciblyOpened);
  };

  const reset = (isForciblyOpened: boolean) => {
    filterStore.reset(props.filterKey);
    emit('reset', isForciblyOpened);
  };

  const apply = (isForciblyOpened: boolean) => {
    increaseZIndex();
    filterStore.search();
    emit('apply', isForciblyOpened);
  };

  const exposedOpenModal = () => {
    calendarPopupRef.value?.open(true);
  };

  defineExpose({
    open: exposedOpenModal,
  });
</script>

<style lang="scss">
  .ui-modal.excursion-filter-popup-modal {
    .ui-modal__body-content-wrapper {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
</style>
